var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a","d":"M94 54V34C94 17.435 80.565 4 64 4 47.435 4 34 17.435 34 34v20H19v70h90V54H94zm-50 0V34c0-11.03 8.97-20 20-20s20 8.97 20 20v20H44z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("g",{"fill":"#FFF","mask":"url(#b)","key":1},React.createElement("path",{"d":"M0 0h128v128H0z"}))])]);
}

Lock.defaultProps = {"width":"128","height":"128","viewBox":"0 0 128 128"};

module.exports = Lock;

Lock.default = Lock;



// WEBPACK FOOTER //
// ./src/Assets/Icons/lock.svg